var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c(
      "div",
      { staticClass: "select-tab-column" },
      _vm._l(["parts", "modules", "frames"], function(select) {
        return _c(
          "div",
          {
            key: select,
            staticClass: "select-tab",
            class: _vm.tab_class_select(select),
            on: {
              click: function($event) {
                _vm.set_selection(select)
              }
            }
          },
          [
            _c("div", { staticClass: "select-tab-text" }, [
              _vm._v(_vm._s(select))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "indicator-lamp-wrapper" }, [
              _c("div", { staticClass: "indicator-lamp-spacer" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "indicator-lamp",
                class: _vm.lamp_class_select(select)
              }),
              _vm._v(" "),
              _c("div", { staticClass: "indicator-lamp-spacer" })
            ])
          ]
        )
      })
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "type-tab-column" },
      _vm._l(_vm.types, function(type) {
        return _c(
          "div",
          {
            key: type,
            staticClass: "type-tab",
            class: _vm.tab_class_type(type),
            on: {
              click: function($event) {
                _vm.set_filter(type)
              }
            }
          },
          [
            _c("div", { staticClass: "type-tab-text" }, [_vm._v(_vm._s(type))]),
            _vm._v(" "),
            _c("div", { staticClass: "indicator-lamp-wrapper" }, [
              _c("div", { staticClass: "indicator-lamp-spacer" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "indicator-lamp",
                class: _vm.lamp_class_type(type)
              }),
              _vm._v(" "),
              _c("div", { staticClass: "indicator-lamp-spacer" })
            ])
          ]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af425d70", { render: render, staticRenderFns: staticRenderFns })
  }
}